import React, { useEffect } from 'react'
import { useNavigate } from '@reach/router';
import { observer, useLocalObservable } from "mobx-react-lite"
import useTitle from '../../hooks/title'
import classes from './Plan.module.scss'
import Button from '@mui/material/Button';
import clsx from 'clsx';

import CreditIcon from '../../components/CreditIcon'
import subscribeStore from './subscribeStore';
import dayjs from 'dayjs'
import SubCancelModal from './SubCancelModal';


const Plan = observer(() => {
  useTitle('Account Plan')
  const navigate = useNavigate();
  const { currentSub, loadSub, showSubPlan, subStatus, showSubCheck } = subscribeStore;
  const currPlan = currentSub && currentSub.plan
  const showPlans = () => navigate('/pricing');
  const model = useLocalObservable(() => ({
    cancelOpen: false,
    onCancelOpen() {
      this.cancelOpen = true
    },
    onCancelClose() {
      this.cancelOpen = false
    }
  }))

  useEffect(() => {
    loadSub()
  }, [loadSub])

  if (!currentSub) {
    return <div className={classes.root}></div>
  }

  if (showSubCheck.isFree || showSubCheck.isNew) {
    return <div className={classes.root}>
      <div className={clsx(classes.panel, classes.newPanel)}>
          <div className={classes.newTips}>You don't have any active subscription.</div>
          <Button className={classes.startPlan} variant="contained" disableElevation onClick={showPlans}>{showSubCheck.isNew ? "Start free trial" : "Start plan"}</Button>
      </div>
    </div>
  }

  return <div className={classes.root}>
    { (showSubCheck.isActive || showSubCheck.isTrial) && <SubCancelModal open={model.cancelOpen} onClose={model.onCancelClose} />}
    <div className={classes.panel}>
      <div className={classes.icon}>
        <CreditIcon size={36} />
      </div>
      <div className={classes.detail}>
        <div className={classes.head}>
          {currPlan && <div className={classes.title}>
            {currPlan.name}
          </div>}
          {showSubCheck.isActive && <div className={clsx(classes.status, classes.active)}>{subStatus}</div>}
          {showSubCheck.isTrial && <div className={clsx(classes.status, classes.trial)}>{subStatus}</div>}
          {showSubCheck.isCancelled && <div className={clsx(classes.status, classes.cancelled)}>{subStatus}</div>}
          {showSubCheck.isNew && <div className={clsx(classes.status, classes.cancelled)}>{subStatus}</div>}
          {showSubCheck.isFree && <div className={clsx(classes.status, classes.cancelled)}>{subStatus}</div>}
        </div>
        {currPlan && <div className={classes.desc}>
          <div className={classes.line}>
          ${currPlan.price}/{currPlan.type == 0 ? 'mo' : 'yr'} with {currPlan.credit} {currPlan.type == 0 ? 'monthly' : 'yearly'} credits
          </div>
          <div className={classes.line}>
            {showSubCheck.isCancelled ? 'Your subscription will expire on ' : 'Your subscription will automatically renew on '}
            {dayjs(currentSub?.subscription?.billing_info?.next_billing_time).format('MMMM D YYYY')}
          </div>
        </div>}
      </div>
      {(showSubCheck.isActive || showSubCheck.isTrial) && <div className={classes.actions}>
        <Button className={classes.primary} onClick={showPlans}>Change Plan</Button>
        <Button className={classes.secondary} onClick={model.onCancelOpen}>Cancel</Button>
      </div>}
      {showSubCheck.isNew && <div className={classes.actions}>
        <Button className={classes.primary} onClick={showPlans}>Start free trial</Button>
      </div>}
      {showSubCheck.isFree && <div className={classes.actions}>
        <Button className={classes.primary} onClick={showPlans}>Start plan</Button>
      </div>}
      {showSubCheck.isCancelled && <div className={classes.actions}>
        <Button className={classes.primary} onClick={showPlans}>Resubscribe</Button>
      </div>}
    </div>
  </div>
})

export default Plan;